<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 85px;">
                    <div class="header-logo">
                        <img id="header-img"
                            src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250923/68d2050686e0c.png">
                    </div>
                    <div class="topTitle">
                        <div class="text1">临里好系统</div>
                        <div class="text2">构建数字家政新时代</div>
                    </div>
                </div>
                <!-- <div style="display:flex; float:left; height: 85px;">
                    <div class="header-important">
                        <div class="company_name">临里好生活</div>
                        <div class="header-title company_name">llhsh.zhelihao123.com</div>
                    </div>
                </div> -->
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
                    style="height: 75px; border:0;padding-top: 10px;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title fontWight">首页</el-menu-item>
                    <el-menu-item index="3" class="header-title fontWight">产品中心</el-menu-item>
                    <!-- <el-menu-item index="6" class="header-title fontWight">服务支持</el-menu-item> -->
                    <el-menu-item index="4" class="header-title fontWight">新闻中心</el-menu-item>
                    <el-menu-item index="5" class="header-title fontWight">关于我们</el-menu-item>
                    <!-- <el-submenu index="2">
                        <template slot="title">产品与解决方案</template>
                        <el-menu-item index="2-1">产品微观</el-menu-item>
                        <el-menu-item index="2-2">生鲜果蔬</el-menu-item>
                        <el-menu-item index="2-3" disabled>服装品牌</el-menu-item>
                        <el-menu-item index="2-4" disabled>微商城小程序</el-menu-item>
                    </el-submenu> -->
                    <!-- <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                    <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                    <el-menu-item index="5" class="header-title">关于我们</el-menu-item> -->
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
                    text-color="#333" style="height: 85px; border:0;" mode="horizontal" @select="handleSelectMobile">
                    <el-submenu index="1" class="header-title mobile_menu">
                        <template slot="title">{{currentMenu}}</template>
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-menu-item index="2-2" class="header-title">生鲜果蔬</el-menu-item>
                        <el-menu-item index="2-1" class="header-title">产品微观</el-menu-item>
                        <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                        <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                        <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div v-if="seen" style="display: flex;align-items: center; height: 100%;">
                <!-- <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
                <el-button type="primary" class="header-title" @click="register" round>注册</el-button> -->
                <div style="margin-right: 25px;color: #666;text-align: center;font-size: 14px;">咨询电话：13396523728</div>
                <el-button type="primary" @click="handleSelect('9')">联系我们</el-button>
                <!-- <el-button @click="login">系统演示</el-button> -->
                <!-- <el-button type="primary" @click="login">免费体验</el-button> -->
            </div>
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <!-- <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div> -->
        <div style="background: #333;display: flex;justify-content: center;align-items: center;color: #fff;padding: 30px 0;gap: 40px;">
            <div class="lefts">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4f15e954b0.png" style="width: 120px;" alt="">
                <div>临里好家政</div>
            </div>
            <div class="lines"></div>
            <div class="centers">
                <div class="fonts1">133-9652-3728</div>
                <div class="fonts2">周一至周日 8:30 - 17:30</div>
                <div class="fonts2">地址：临安区钱王街28号（职工之家）1号楼12楼</div>
                <div class="fonts2">临里好（杭州）科技有限公司</div>
            </div>
            <div class="lines"></div>
            <div class="rights" style="text-align: center;">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d4f2cd09fa6.png" style="width: 130px;" alt="">
                <div>关注我们</div>
            </div>

            <div class="rights" style="font-size: 20px;">
                <div>搜索“临里好家政”</div>
                <div>免费体验小程序</div>
            </div>
        </div>
        <div style="background: #333;text-align: center;color: #fff;padding-bottom: 30px;cursor: pointer;" @click="goView">浙ICP备2021037953号 增值电信业务许可证：浙B2-20250255</div>
        <!-- <div style="width: 90%;margin: 20px auto;">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12">
                    <p class="footer_font">邮箱：</p>
                    <div style="margin: auto;" class="footer_font">
                        互联网ICP备案：
                    </div>
                    <div style="margin: auto;" class="footer_font">
                         临里好（杭州）科技有限公司版权所有
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div><img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20240824/66c959315f094.jpg"
                            style="width: 100px;height: 100px;border: 0" /></div>
                    <div class="footer_font">关注公众号</div>
                </el-col>
            </el-row>
        </div> -->
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                company:{
                    qrcode: require("../../static/other/公众号二维码.jpg"),
                },
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页'
            };
        },
        methods: {
            //  switch (key){
            //         case '1':
            //             this.$router.push({name: "Index"});
            //             break;
            //         case '2-1':
            //             window.location.hash = "#产品微观";
            //             break;
            //         case '2-2':
            //             this.$router.push({name: "Fruit"});
            //             break;
            //         case '2-3':
            //             this.$router.push({name: "Fashion"});
            //             break;
            //         case '3':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#产品特点";
            //             break;
            //         case '4':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#合作伙伴";
            //             break;
            //         case '5':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#关于我们";
            //             break;
            //     }
            handleSelect(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2-1':
                        window.location.hash = "#产品微观";
                        break;
                    case '2-2':
                        this.$router.push({name: "Fruit"});
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Product"});
                        break;
                    case '4':
                        this.$router.push({name: "News"});
                        // window.location.hash = "#合作伙伴";
                        break;
                    case '5':
                        this.$router.push({name: "Main"});
                        // window.location.hash = "#关于我们";
                        break;
                    case '9':
                        this.$router.push({name: "Infos"});
                        break;
                }
            },
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        this.currentMenu='首页';
                        break;
                    case '2-1':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品微观";
                        this.currentMenu='首页';
                        break;
                    case '2-2':
                        this.$router.push({name: "Fruit"});
                        this.currentMenu='生鲜果蔬';
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        this.currentMenu='首页';
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        this.currentMenu='首页';
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        this.currentMenu='首页';
                        break;
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                    this.$refs.btn.style.display = 'block';
                }else{
                    this.$refs.btn.style.display = 'none'
                }
            },
            goView(){
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            login(){
                window.open('https://llhsh.zhelihao123.com/admin/')
            },
            register() {
                window.open('https://llhsh.zhelihao123.com/admin/')
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            },
            getTitle(){
                axios.defaults.headers.common['APPKEY'] = 'official';
                var query = {}
                axios.post(window.location.origin + '/user/member/official/info',query)
                    .then(response => {
                        console.log('titles='+JSON.stringify(response))
                        if(response.data.data.title){
                            document.title = response.data.data.title
                        }
                        if(response.data.data.keywords){
                            const keywords = document.querySelector('meta[name="keywords"]');
                            if (keywords) {
                                keywords.setAttribute('content', response.data.data.keywords)
                            }
                        }
                        if(response.data.data.conmtent){
                            const metaKeywords = document.querySelector('meta[name="description"]');
                            if (metaKeywords) {
                                metaKeywords.setAttribute('content', response.data.data.conmtent);
                            }
                        }
                })
            },
        },
        mounted() {
            this.menuSeen()
            this.getTitle()
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped>
    .logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .footer_font{
        font-size: 1em;
    }
    #menu_index{
        float: left; width: 50%;height: 100%
    }
    .header{
        margin: auto;
        width: 90%;
        height: 85px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
    }
    #header-img{
        width: 55px;
        height: 55px;
        float: left;
        margin: auto;
    }
    .topTitle{
        color: #330000;
        font-weight: bold;
        margin-left: 15px;
        font-family: "Times New Roman", Times, serif;
    }
    .text1{
        font-size: 32px;
    }
    .text2{
        font-size: 18px;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
    .lefts{color: #fff;font-size: 22px;}
    .fonts1{font-size: 30px;margin-bottom: 15px;}
    .fonts2{font-size: 18px;font-weight: 400;}
    .lines{width: 2px;height: 150px;background: #fff;}
    .fontWight{font-size: 16px;}
</style>